// NOTICE: KAPTION-INTEGRATION - Feature Management (client-managed permission layer)
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/feature-management'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_feature_management',
          component: () => import('./Index.vue'),
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
